export const buildQueryParams = (filtros = {}) => {
  const params = new URLSearchParams();

  if (filtros.estado) {
    params.append("estado", filtros.estado);
  }

  if (filtros.soloPendientesDeAplicar) {
    params.append("soloPendientes", "true");
  }

  if (filtros.fechaInicio) {
    params.append("fechaInicio", filtros.fechaInicio);
  }

  if (filtros.fechaFin) {
    params.append("fechaFin", filtros.fechaFin);
  }

  if (filtros.ordenarDatos) {
    params.append("orden", filtros.ordenarDatos);
  }

  if (filtros.tipos?.length > 0) {
    params.append("tipos", filtros.tipos.join(","));
  }

  if (filtros.resumenesConDetalles != null) {
    params.append("resumenesConDetalles", filtros.resumenesConDetalles);
  }

  return params.toString();
};
